import { render, staticRenderFns } from "./AccountMenu.vue?vue&type=template&id=99c4b770&scoped=true&"
import script from "./AccountMenu.vue?vue&type=script&lang=js&"
export * from "./AccountMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99c4b770",
  null
  
)

export default component.exports
import {QMenu,QAvatar,QSeparator,QBtn,QList,QItem,QItemSection,QIcon,ClosePopup,Ripple} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QMenu,QAvatar,QSeparator,QBtn,QList,QItem,QItemSection,QIcon})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup,Ripple})
